export default __webpack_public_path__ + "static/media/groundUp.7fea07a4.jpg";